import FastClick from 'fastclick'
import * as utils from './utils.js';
import {initHome} from './pages/home.js';
import {initSingle} from './pages/single.js';
import {initInvite} from './pages/invite.js';
import {initArchiveInvite} from './pages/archive-invite.js';

const body = document.querySelector('body');
const menuToggle = document.querySelector('.menu__toggle');
const toTop = document.querySelector('#totop');

class App {

    constructor(opt = {}) {

        window.scrollTo(0, 0)
        console.log("%cCreated by wokine", "color: #000; padding: 5px 0px;"), console.log("%chttp://wokine.com", "color:#ccc")

        this.init();
        this.addEvents();

    }

    init() {

        FastClick(document.body);

        //removeLoading
        document.querySelector('body').classList.remove('is-loading');

        //menuToggle
        menuToggle.addEventListener('click', (e) => {
          e.preventDefault();
          body.classList.toggle('openMenu');
          menuOpen = !menuOpen;
        })

        //toTop
        toTop.addEventListener('click', (e) => {
            e.preventDefault();
            TweenMax.to(window, 1.2, {scrollTo: {y: 0, autoKill: false}, ease: Power3.easeInOut});
        });

        //routes
        if (document.querySelector('main.homepage')) initHome();
        if (document.querySelector('article.single--video')) initSingle();
        if (document.querySelector('article.single--invite')) initInvite();
        if (document.querySelector('main.page-invites')) initArchiveInvite();

        const formNewsletter = $(".formNewsletter, .formBookSendDownload");
        if (formNewsletter.length > 0) {
            formNewsletter.submit(function (e) {
                const form = $(e.target);
                e.preventDefault();

                var formResult = form.find(".form-results");

                var ajaxurl = form.data("ajaxurl");
                var data = form.serializeArray();

                $("body").css("cursor", "wait");

                $.ajax({
                    type: "POST",
                    url: ajaxurl,
                    data: data,
                    success: function (data) {
                        formResult.removeClass("error")
                            .text(data);
                        e.target.reset();
                        $("body").css("cursor", "default")
                    },
                    error: function (response) {
                        formResult.addClass("error")
                            .text(response.responseText)
                        $("body").css("cursor", "default")
                    }
                });

            });
        }

        const inviteFriendForm = $(".inviteFriend");
        if (inviteFriendForm.length){
            inviteFriendForm.submit(function (e) {
                e.preventDefault();
                const form = $(e.target);

                var callback = form.find(".form-results");

                var ajaxurl = form.data("ajaxurl");
                var data = form.serializeArray();
                $("body").css("cursor", "wait");

                $.ajax({
                    type: "POST",
                    url: ajaxurl,
                    data: data,
                    success: function (data) {
                        callback.removeClass("error")
                            .text(data)
                        $("body").css("cursor", "default")
                    },
                    error: function (response) {
                        callback.addClass("error")
                            .text(response.responseText)
                        $("body").css("cursor", "default")
                    }
                });
            })
        }

        const shareBlock = $("#shareblock");
        if (shareBlock.length){
            shareBlock.jsSocials({
                shareIn: "popup",
                shares: ["email", "twitter", "facebook", "linkedin"]
            });
        }


        /*const shareFriendForm = $(".shareFriend");
        if (shareFriendForm.length){
            shareFriendForm.submit(function (e) {
                e.preventDefault();
                const form = $(e.target);

                var callback = form.find(".form-results");

                var ajaxurl = form.data("ajaxurl");
                var data = form.serializeArray();
                $("body").css("cursor", "wait");

                $.ajax({
                    type: "POST",
                    url: ajaxurl,
                    data: data,
                    success: function (data) {
                        callback.removeClass("error")
                            .text(data)
                        $("body").css("cursor", "default")
                    },
                    error: function (response) {
                        callback.addClass("error")
                            .text(response.responseText)
                        $("body").css("cursor", "default")
                    }
                });
            })
        }*/



/*        setTimeout(function () {
            $.magnificPopup.open({
                items: {
                    src: '#addBook'
                },
                mainClass: 'mfp-fade',
                fixedContentPos: true,
                type: 'inline'
            });
        }, 2000);*/

    }

    addEvents() {

        window.addEventListener('scroll', (e) => {
            this.sy = window.pageYOffset || document.documentElement.scrollTop;
            if (this.sy > window.innerHeight) toTop.classList.remove('hidden');
            else toTop.classList.add('hidden');

        })
    }

}

const app = new App();
